import { ChangeEvent, MouseEvent, useState } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';

import { CustomAlert, CustomButton, CustomInput, Text } from '../../../../../shared/uiComponents';
import { errorNormalizer } from '../../../../../shared/Helpers/functions';
import { EditSvg } from '../../../../../shared/Assets/svgIcons';
import { ButtonWrapper } from '../../../../../components/StyledComponents';

import { DispatchProperties, useSelector } from '../../../../../redux/store';
import { SkillAreaProperties, SkillProperties } from '../../../../../redux/API/ClientAPIHelpers/skillAreaProperties';
import { getSkillAreas, updateSkillAreas } from '../../../../../redux/State/clientSlice/skillAreaSlice';

const Rename = ({ item }: { item: SkillProperties }) => {
	const dispatch = useDispatch<DispatchProperties>();

	const [open, setOpen] = useState<boolean>(false);
	const [name, setName] = useState<string>(item.name);

	const isUpdating = useSelector((state) => state.skillArea.isUpdating);

	const onEditClick = (event: MouseEvent<HTMLDivElement>) => {
		event.stopPropagation();
		setOpen(true);
	};

	const refreshSkillAreas = () => {
		const { clientId } = item;

		if (!clientId) return;
		dispatch(getSkillAreas({ clientId }));
	};

	const updateSkillAreaHandler = () => {
		const { clientId, id } = item;

		if (!clientId || !id) return;
		const data: SkillAreaProperties = {
			clientId,
			name,
		};
		dispatch(updateSkillAreas({ data, id }))
			.then(unwrapResult)
			.then(() => {
				setOpen(false);
				refreshSkillAreas();
			})
			.catch(errorNormalizer);
	};

	const nameHandler = (event: ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value;
		setName(value);
	};

	return (
		<>
			<div className="actionRow" onClick={onEditClick}>
				<div className="actionIcon">
					<EditSvg color="#62615F" />
				</div>
				<div className="actionContent">
					<Text title="Rename" type="psm" fontWeight="medium" />
				</div>
			</div>
			<CustomAlert
				isBusy={isUpdating}
				open={open}
				onClose={() => setOpen(false)}
				title="Edit skill acquisition name"
				Content={() => (
					<div>
						<CustomInput value={name} onChange={nameHandler} className="marginBottom16" />
						<ButtonWrapper isInModal>
							<CustomButton title="Save" onClick={updateSkillAreaHandler} />
							<CustomButton title="Cancel" buttonType="secondaryGray" onClick={() => setOpen(false)} />
						</ButtonWrapper>
					</div>
				)}
			/>
		</>
	);
};

export default Rename;
